import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Input, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import { api, dateHelpers, filterHelpers, helpers } from "../utils";
import { FilterMultiSelect } from '.';

export default function POEditCostModal({
   editId,
   toggleCallback,
   callbackRefresh,
}) {
   const [filters, setFilters] = useState([
      { filterName: "receipts", value: [] },
   ]);
   const [dto, setDto] = useState({
      cartage: 0,
      cashAdvanceFee: 0,
      container: "",
      courierFee: 0,
      customsFee: 0,
      documentDate: null,
      duty: 0,
      enteredBy: "",
      enteredDate: null,
      freight: 0,
      harborFee: 0,
      id: 0,
      insurance: 0,
      items: [],
      lateFee: 0,
      merchandiseFee: 0,
      pOAttachmentCount: 0, // what does this actually look like?
      poNum: "",
      qtyShipped: 0,
      receipts: [],
      securityFee: 0,
      shipMethod: "",
      vendorId: "",
      vendorWithName: ""
   });
   const [receipts, setReceipts] = useState([]); // PoNum, ReceiptDate, ReceiptNum, Price
   const [selectRcpts, setSelectRcpts] = useState([]);
   const [message, setMessage] = useState();
   const [working, setWorking] = useState(false);

   useEffect(() => {
      //console.log(editId);
      if (editId === null || editId === undefined || editId === 0)
         return;

      setWorking(true);
      api
         .fetch(`Purchasing/GetLandedCost/${editId}`)
         .then(r => {
            if (r.data.success) {
               if (r.data.message?.landedCost !== null && r.data.message?.landedCost !== undefined)
                  setDto(r.data.message.landedCost);
               const rcptOpts = _.concat(
                  _.map(r.data.message.receipts, (p) => ({
                     value: p.receiptNum,
                     label: p.receiptDisplay,
                     rctDate: dateHelpers.formatDateToShortDate(p.receiptDate)
                  }))
               );
               return {
                  rcpts: rcptOpts
               };
            } else {
               setMessage(r.data.message);
               return {
                  rcpts: []
               };
            }
         }).then(({ rcpts }) => {
            setReceipts(rcpts);
         })
         .catch((error) => {
            api.catchHandler(error);
            setMessage(error);
         })
         .finally(() => setWorking(false))
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [editId]);
   
   function onChange(field, value) {
      let changes = Object.assign({}, dto);
      changes[field] = value;
      setDto(changes);
   }

   function onFilterChange(changedFilter) {
      const filterChanges = filterHelpers.getFilters(filters, changedFilter);
      setFilters(filterChanges);

      const nextSelected = (changedFilter.value || [])
         .map((v) => {
            const rt = _.find(receipts, (x) => x.value === v);
            if (!rt) return null;
            return {
               container: dto?.container || "",
               id: 0,
               poNum: dto?.poNum || "",
               receiptDate: rt.rctDate
                  ? dateHelpers.formatDateForServer(rt.rctDate)
                  : null,
               receiptNum: rt.value,
               price: 0,
            };
         })
         .filter(Boolean);

      setSelectRcpts(nextSelected);
   }

   function onSave() {
      if (dto?.container === "") {
         setMessage("Missing Container. Please close this dialog, go add a container, and try again.");
         return;
      }

      if (selectRcpts.length > 0)
         dto.receipts = selectRcpts;

      //console.log(dto);
      setWorking(true);
      api
         .post("Purchasing/UpdateLandedCost", dto)
         .then((r) => {
            if (r.data.success) {
               callbackRefresh();
            } else {
               setMessage(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWorking(false));
   }

   return (
      <Modal isOpen={true} toggle={toggleCallback}>
         <ModalHeader toggle={toggleCallback}>
            <span>Edit Landed Cost</span>
         </ModalHeader>
         <ModalBody>
            <Table striped>
               <tbody>
                  <tr>
                     <td colSpan="2">PO Number: {dto?.poNum}</td>
                  </tr>
                  <tr>
                     <td colSpan="2">Container: {dto?.container}</td>
                  </tr>
                  <tr>
                     <td colSpan="2">Ship Method: {dto?.shipMethod}</td>
                  </tr>
                  <tr>
                     <td colSpan="2">Total LBS: {helpers.formatNumberWithThousands(dto?.qtyShipped) || 0}</td>
                  </tr>
                  <tr>
                     <td>Current Receipt(s):</td>
                     <td>
                        <pre>{dto.receiptDisplay}</pre>
                     </td>
                  </tr>
                  <tr>
                     <td>Select to Change:</td>
                     <td>
                        <FilterMultiSelect
                           filterName="receipts"
                           options={receipts}
                           values={filterHelpers.getValue(filters, "receipts")}
                           onChangeCallback={(e) => onFilterChange(e)}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Int'l Freight:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.freight}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("freight", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Merch. Fee:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.merchandiseFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("merchandiseFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Harbor Fee:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.harborFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("harborFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Duty:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.duty}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("duty", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Cash Advance:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.cashAdvanceFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("cashAdvanceFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Courier Fee:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.courierFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("courierFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Customs Fee:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.customsFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("customsFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Dest. Cartage:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.cartage}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("cartage", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>ISF Fee:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.securityFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("securityFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Insurance:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.insurance}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("insurance", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td>Late/Other:</td>
                     <td>
                        <Input className="no-spinner"
                           type="number"
                           value={dto?.lateFee}
                           onChange={(e) => {
                              if (e.target.value.match(/^\d{1,}(\.\d{0,2})?$/))
                                 onChange("lateFee", e.target.value);
                           }}
                        />
                     </td>
                  </tr>
               </tbody>
            </Table>
            <Row>
               <Col xs={6} className="text-center">
                  <Button
                     className="shredButton w-100"
                     onClick={onSave}
                     disabled={working}
                  >
                     Update
                  </Button>
               </Col>
               <Col xs={6} className="text-center">
                  <Button
                     className="shredButton w-100"
                     onClick={toggleCallback}
                     disabled={working}
                  >
                     Cancel
                  </Button>
               </Col>
            </Row>
            {!_.isNil(message) && message.length > 0 && (
               <Row className="mt-3 mb-0 pb-0">
                  <Col>
                     <Alert color="danger">{message}</Alert>
                  </Col>
               </Row>
            )}
         </ModalBody>
      </Modal>
   );
}
